const internals = {
  errorReason: 'An error ocurred, we have notified the administrators.',
  tryMsg: 'In the meantime, try to ',
  anchorMsg: 'refresh this page.',
  url: '/',
  anchorClass: ''
};

const ErrorMsg = (props) => {
  const options = Object.assign({}, internals, props);

  const reloadPage = (e) => {
    e.preventDefault();
    window.location.reload(true);
  };

  return (
    <section className="txt-center">
      <h3 className="wddng-styler-no-data-error">Something went wrong.</h3>
      <span>{`${options.errorReason}`}</span>
      <span className="display-block">{`${options.tryMsg}`}<a className={`wddng-link ${options.anchorClass}`} href={`${options.url}`} onClick={ (options.url === '/') ? reloadPage : undefined }>{`${options.anchorMsg}`}</a></span>
    </section>
  );
};

export default ErrorMsg;
